<div class="kodit-card-tab">
  <p-tabView
    [(activeIndex)]="activeIndex"
    (activeIndexChange)="handleIndexChange($event)"
  >
    <p-tabPanel header="Data obaveštenja"></p-tabPanel>
    <p-tabPanel header="Primljena obaveštenja"></p-tabPanel>
  </p-tabView>

  <div [ngSwitch]="activeIndex">
    <div *ngSwitchCase="0">
      <kodit-page>
        <kodit-dato-obavestenje-table></kodit-dato-obavestenje-table>
      </kodit-page>
    </div>
    <div *ngSwitchCase="1">
      <kodit-page>
        <kodit-primljeno-obavestenje-table></kodit-primljeno-obavestenje-table>
      </kodit-page>
    </div>
  </div>
</div>
